import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getStates } from "../../modules/utils";
import TextFieldGroup from "../../reusable/TextFieldGroup";
import Validator from "validator";
import isEmpty from "lodash/isEmpty";

function validateInput(data) {
  let errors = {};
  if (!data.firstname || Validator.isEmpty(data.firstname)) {
    errors.firstname = "This field is required";
  }
  if (!data.lastname || Validator.isEmpty(data.lastname)) {
    errors.lastname = "This field is required";
  }
  if (!data.address1 || Validator.isEmpty(data.address1)) {
    errors.address1 = "This field is required";
  }
  if (!data.city || Validator.isEmpty(data.city)) {
    errors.city = "This field is required";
  }
  if (!data.state || Validator.isEmpty(data.state)) {
    errors.state = "This field is required";
  }
  if (!data.country || Validator.isEmpty(data.country)) {
    errors.country = "This field is required";
  }
  if (!data.zipcode || Validator.isEmpty(data.zipcode)) {
    errors.zipcode = "This field is required";
  }
  return {
    errors,
    isValid: isEmpty(errors)
  };
}

class ShippingAddress extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.defaultState();
  }

  defaultState = () => {
    return {
      firstname: "",
      lastname: "",
      address1: "",
      address2: "",
      country: "US",
      city: "",
      state: "",
      zipcode: "",
      errors: {},
      isLoading: false
    };
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.auth.profile.userShipping) {
      this.setState({
        ...this.state,
        ...nextProps.auth.profile.userShipping,
        firstname : nextProps.auth.profile.firstname,
        lastname : nextProps.auth.profile.lastname,
      });
    }else{
      this.setState({
        firstname : nextProps.auth.profile.firstname,
        lastname : nextProps.auth.profile.lastname
      })
    }
  }

  _onChange = event => {
    console.log(event);
    const field = event.target.name;
    const value = event.target.value;
    this.setState({ [field]: value });
  };

  isValid() {
    const { errors, isValid } = validateInput(this.state);
    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }

  goBack = event => {
    event.preventDefault();
    this.props.back();
  };

  handleShipping = event => {
    event.preventDefault();
    const {
      firstname,
      lastname,
      address1,
      address2,
      country,
      city,
      state,
      zipcode
    } = this.state;

    const shipping = {
      firstname,
      lastname,
      address1,
      address2,
      country,
      city,
      state,
      zipcode
    };

    if (this.isValid()) {
      this.setState({ errors: {}, isLoading: true });
      this.props.handleShipping(shipping);
    }
  };

  render() {
    const {
      errors,
      firstname,
      lastname,
      address1,
      address2,
      country,
      city,
      state,
      zipcode
    } = this.state;

    console.log(errors);
    return (
        <div className="col-md-8 services_clip">
          <div className="">
            <div className="row">
              <div className="col-lg-12">
                <div className="services_boxes">
                  <div className="services_content">
                    <h2 className="mb-0">Shipping Address</h2>
                    <div style={{ clear: "both", height: "15px" }} />
                    <p className="m-0">Free shipping via First Class USPS in the US</p>
                    <p className="m-0">For international shipping, please contact us by email: support@mightywifi.net</p>
                    <div style={{ clear: "both", height: "15px" }} />

                    <div className="row">

                      <div className="col-lg-6">
                          <TextFieldGroup
                              field="firstname"
                              value={firstname}
                              error={errors.firstname}
                              onChange={this._onChange}
                              placeholder="First Name"
                              error={errors.firstname}
                          />
                      </div>
                      <div className="col-lg-6">
                          <TextFieldGroup
                              field="lastname"
                              value={lastname}
                              error={errors.lastname}
                              onChange={this._onChange}
                              placeholder="Last Name"
                              error={errors.lastname}
                          />
                        </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                          <TextFieldGroup
                              field="address1"
                              value={address1}
                              error={errors.lastname}
                              onChange={this._onChange}
                              placeholder="Address Line 1"
                              error={errors.address1}
                          />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                          <TextFieldGroup
                              field="address2"
                              value={address2}
                              error={errors.lastname}
                              onChange={this._onChange}
                              placeholder="Address Line 2"
                              error={errors.address2}
                          />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                          <TextFieldGroup
                              field="city"
                              value={city}
                              error={errors.city}
                              onChange={this._onChange}
                              placeholder="City"
                              error={errors.city}
                          />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-12">
                        <select
                            name="state"
                            onChange={this._onChange}
                            className="state form-control"
                            value={state}
                        >
                          <option value="">State</option>;
                          {getStates().map(function(state, index) {
                            return (
                                <option key={index} value={state.abbreviation}>
                                  {state.name}
                                </option>
                            );
                          })}
                        </select>

                        {errors.state && (
                            <span className="error-color">{errors.state}</span>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3">
                        <TextFieldGroup
                            field="zipcode"
                            value={zipcode}
                            error={errors.zipcode}
                            onChange={this._onChange}
                            placeholder="ZIP code"
                            error={errors.zipcode}
                        />
                      </div>
                      <div className="col-lg-3">
                        <TextFieldGroup
                            field="country"
                            value={country}
                            error={errors.country}
                            onChange={this._onChange}
                            placeholder="US"
                            error={errors.country}
                            disabled
                        />
                      </div>
                    </div>

                    <div style={{ clear: "both", height: "40px" }} />

                    <div className="row">
                    <div className="col-lg-12">
                      <a
                          href="javascript:void(0)"
                          onClick={this.goBack}
                          className="btn btn-white mr-15"
                      >
                        Back
                      </a>
                      <a
                          href="javascript:void(0)"
                          onClick={this.handleShipping}
                          className="btn btn-orange"
                      >
                        CONTINUE
                      </a>
                    </div>
                    </div>
                    <div style={{ clear: "both", height: "100px" }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

export default connect(mapStateToProps)(ShippingAddress);



// WEBPACK FOOTER //
// ./src/pages/checkout/ShippingAddress.js